import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  ANALYTICS_CONFIG,
  initGA4,
  initClarity,
  trackPageview,
  trackEvent,
} from "@/lib/analytics";

/**
 * Analytics — loads GA4 + Microsoft Clarity (if configured), tracks SPA
 * pageviews on route change, and listens globally for tel:/mailto: clicks
 * so contact intent is captured anywhere on the site. Mount once at the
 * App root.
 */
export default function Analytics() {
  const location = useLocation();

  // One-time bootstrap of GA4 + Clarity + GSC verification tag
  useEffect(() => {
    initGA4();
    initClarity();

    const token = ANALYTICS_CONFIG.GOOGLE_SITE_VERIFICATION;
    if (token && !document.querySelector('meta[name="google-site-verification"]')) {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "google-site-verification");
      meta.setAttribute("content", token);
      document.head.appendChild(meta);
    }
  }, []);

  // Track pageview on every route change
  useEffect(() => {
    trackPageview(location.pathname, location.search);
  }, [location.pathname, location.search]);

  // Track every phone / email click anywhere on the site
  useEffect(() => {
    const handler = (e) => {
      const link = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
      if (!link) return;
      const href = link.getAttribute("href") || "";
      const method = href.startsWith("tel:") ? "phone" : "email";
      const value = href.replace(/^(tel:|mailto:)/, "");
      trackEvent("contact_click", {
        method,
        value,
        page_path: location.pathname,
      });
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [location.pathname]);

  return null;
}
